const raw = import.meta.env.VITE_API_URL?.trim();

/** Базовый URL API. В dev по умолчанию — прокси Vite на /api/v1 */
export const apiConfig = {
  baseUrl: raw && raw.length > 0 ? raw.replace(/\/$/, "") : "/api/v1",
};

export function isApiEnabled(): boolean {
  return Boolean(apiConfig.baseUrl);
}
